import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faBars,
  faCheck,
  faChevronLeft,
  faClipboard,
  faCog,
  faDesktop,
  faDownload,
  faEdit,
  faEllipsisH,
  faFile,
  faFileExport,
  faFolder,
  faFolderOpen,
  faGlobe,
  faLongArrowAltDown,
  faLongArrowAltUp,
  faPlus,
  faSave,
  faSpinner,
  faTimes,
  faTrashAlt,
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons';

import {
  faDropbox,
  faGithub,
} from '@fortawesome/free-brands-svg-icons';

library.add(
  faBars,
  faCheck,
  faChevronLeft,
  faClipboard,
  faCog,
  faDesktop,
  faDownload,
  faDropbox,
  faEdit,
  faEllipsisH,
  faFile,
  faFileExport,
  faFolder,
  faFolderOpen,
  faGithub,
  faGlobe,
  faLongArrowAltDown,
  faLongArrowAltUp,
  faPlus,
  faSave,
  faSpinner,
  faTimes,
  faTrashAlt,
  faQuestionCircle,
);
